module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picklist"
  }, [_c('el-select', {
    staticClass: "rt-saas-item-select",
    attrs: {
      "clearable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.comselect),
      callback: function($$v) {
        _vm.comselect = $$v
      },
      expression: "comselect"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$_t(item.text, item.name),
        "value": item.value
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d53912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/vflow/picklist-component.vue
// module id = 2130
// module chunks = 228